export default "__VITE_ASSET__BAQnH7Dp__"